@if (formGroup) {
  <div class="project-name-suggestions-container">
    <div class="project-name-search-panel" >
      @if (!initialValue) {
        <span class="search-icon">
          <i class="icon-search4"></i>
        </span>
      }
      <input [formControl]="projectNameControl" placeholder="Search" type="text" class="form-control" [matAutocomplete]="projectNamesAutocomplete">
    </div>
    <mat-autocomplete #projectNamesAutocomplete="matAutocomplete"
      (optionSelected)="projectNameClicked($event)">
      @for (projectName of projectSuggestions$ | async; track projectName) {
        <mat-option [value]="projectName">
          <span class="project-name-hit">
            {{projectName}}
          </span>
        </mat-option>
      }
    </mat-autocomplete>
    <div class="hub-validation-error-message">
      {{getProjectNameErrorMessage()}}
    </div>
  </div>
}
